export default "__VITE_ASSET__8d08d080__"